import { TableIcon } from "./TableIcon";

export const HorizontalTableIcon = (props) => <TableIcon shape="horizontalRectangle" {...props} />;
